import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress noisy runtime errors from browser extensions (MetaMask, Phantom,
// etc.) which inject scripts into every page and surface failures via the
// React/CRA error overlay even though they have nothing to do with our app.
const isExtensionError = (msg, source) => {
  const text = `${msg || ""} ${source || ""}`.toLowerCase();
  return (
    text.includes("chrome-extension://") ||
    text.includes("moz-extension://") ||
    text.includes("safari-extension://") ||
    text.includes("metamask") ||
    text.includes("failed to connect to metamask") ||
    text.includes("ethereum") && text.includes("inpage")
  );
};

window.addEventListener("error", (event) => {
  if (isExtensionError(event?.message, event?.filename) ||
      isExtensionError(event?.error?.message, event?.error?.stack)) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason;
  const msg = typeof reason === "string" ? reason : (reason?.message || "");
  const stack = reason?.stack || "";
  if (isExtensionError(msg, stack)) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Belt-and-suspenders: react-error-overlay sometimes still shows the iframe
// even after we suppress the underlying error. Watch the DOM and remove any
// overlay whose content mentions a browser-extension origin.
const removeExtensionOverlays = () => {
  document.querySelectorAll("iframe").forEach((iframe) => {
    try {
      const body = iframe.contentDocument?.body;
      if (!body) return;
      const text = (body.innerText || "").toLowerCase();
      if (
        text.includes("chrome-extension://") ||
        text.includes("moz-extension://") ||
        text.includes("metamask") ||
        text.includes("failed to connect to metamask")
      ) {
        iframe.remove();
      }
    } catch (_) {
      // Cross-origin iframes will throw — ignore.
    }
  });
};
const startOverlayWatcher = () => {
  if (!document.body) return;
  const observer = new MutationObserver(() => removeExtensionOverlays());
  observer.observe(document.body, { childList: true, subtree: true });
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startOverlayWatcher);
} else {
  startOverlayWatcher();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
